import { Components, Theme } from '@mui/material/styles';

const buttonTheme: Components<Theme>['MuiButton'] = {
  variants: [
    {
      props: { variant: 'text' },
      style: ({ theme }) => ({
        background: 'none',
        color: theme.palette.corporateBlue,
        '&.MuiButton-text:hover': {
          color: theme.palette.corporateBlue,
          background: 'none',
        }
      }),
    },
    {
      props: { variant: 'oval' },
      style: ({ theme }) => ({
        background: theme.palette.primary.main,
        zIndex: 100,
        opacity: 0.8,
        color: theme.palette.neutralWhite,
        borderRadius: '32px',
        '&:hover, &:focus, &:active': {
          backgroundColor: theme.palette.primary.main,
        },
        '& svg': {
          display: 'inline-block',
          marginRight: theme.spacing(1),
        },
      }),
    },
    {
      props: { variant: 'fixed-right' },
      style: ({ theme }) => ({
        [theme.breakpoints.up('xs')]: {
          position: 'fixed',
          right: '10px',
          bottom: '10px',
        },
        [theme.breakpoints.up('md')]: {
          position: 'absolute',
          right: 0,
          bottom: '-40px',
        },
        textTransform: 'capitalize',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.neutralWhite,
        pt: theme.spacing(0.5),
        pb: theme.spacing(0.5),
        opacity: 0.8,
        '&:hover, &:focus, &:active': {
          backgroundColor: theme.palette.primary.main,
        },
      }),
    },
    {
      props: { variant: 'expand-icon' },
      style: ({ theme }) => ({
        '&.Mui-disabled': {
          background: theme.palette.corporateBlue,
          opacity: '0.6',
        },
        '& .MuiSvgIcon-root': {
          fill: theme.palette.neutralWhite,
          transform: 'rotate(90deg)',
          width: '20px',
          fontSize: '1rem',
          '&.open': {
            transform: 'rotate(-90deg)',
          }
        },
        '&:hover': {
          background: theme.palette.corporateBlue,
          '& svg': {
            fill: theme.palette.neutralWhite,
          },
        },
        background: theme.palette.corporateBlue,
        borderRadius: 0,
        padding: 0,
        minWidth: 'unset'
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: '16px',
      '&.MuiButton-contained': {
        backgroundColor: theme.palette.corporateBlue,
        color: theme.palette.neutralWhite,
        fontFamily: theme.typography.fontFamily,
        textTransform: 'capitalize',
        minWidth: '100px',
        '&:hover': {
          backgroundColor: theme.palette.corporateBlue,
        },
        '&:disabled': {
          backgroundColor: theme.palette.coldWhite,
          color: theme.palette.offGray,
        },
      },
      '&.MuiButton-text': {
        color: theme.palette.corporateBlue,
        fontFamily: theme.typography.fontFamily,
        textTransform: 'capitalize',
        '&.MuiButton-textSecondary': {
          color: 'white',
          textTransform: 'uppercase',
          '&:hover': {
            color: 'white',
            background: 'transparent',
          },
        },
        '&:hover': {
          color: theme.palette.corporateBlue,
          background: theme.palette.neutralWhite,
        },
        '&:disabled': {
          color: theme.palette.offGray,
          background: theme.palette.neutralWhite,
        },
      },
      '&.MuiButton-outlined': {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '4px',
        color: theme.palette.blue[900],
        background: theme.palette.grey.A450,
        fontWeight: 'bold',
        padding: 0,
        '&:hover': {
          background: theme.palette.grey.A450,
          cursor: 'default',
        },
      },
    }),
  },
};

export default buttonTheme;
